export default "__VITE_ASSET__C4j7oh_x__"